const StrategyLayout = <template>{{outlet}}</template>;

export default StrategyLayout;
